'use client';

import { useState, useEffect } from 'react';


interface Template {
  id: number;
  title: string;
  description: string;
  icon: string;
  pages: number;
  category: string;
}

interface AgreementTemplatesProps {
  templates: Template[];
}

export default function AgreementTemplates({ templates }: AgreementTemplatesProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/partnership-models/components/AgreementTemplates.tsx:28:6" data-component-path="src/app/partnership-models/components/AgreementTemplates.tsx" data-component-line="28" data-component-end-line="39" data-component-file="AgreementTemplates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-6%22%7D" className="space-y-6">
        <div data-component-id="src/app/partnership-models/components/AgreementTemplates.tsx:29:8" data-component-path="src/app/partnership-models/components/AgreementTemplates.tsx" data-component-line="29" data-component-end-line="33" data-component-file="AgreementTemplates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20flex%20space-x-4%22%7D" className="animate-pulse flex space-x-4">
          {[1, 2, 3, 4].map(i => (
            <div data-component-id="src/app/partnership-models/components/AgreementTemplates.tsx:31:12" data-component-path="src/app/partnership-models/components/AgreementTemplates.tsx" data-component-line="31" data-component-end-line="31" data-component-file="AgreementTemplates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-10%20bg-surface%20rounded%20w-24%22%7D" key={i} className="h-10 bg-surface rounded w-24"></div>
          ))}
        </div>
        <div data-component-id="src/app/partnership-models/components/AgreementTemplates.tsx:34:8" data-component-path="src/app/partnership-models/components/AgreementTemplates.tsx" data-component-line="34" data-component-end-line="38" data-component-file="AgreementTemplates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20gap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map(i => (
            <div data-component-id="src/app/partnership-models/components/AgreementTemplates.tsx:36:12" data-component-path="src/app/partnership-models/components/AgreementTemplates.tsx" data-component-line="36" data-component-end-line="36" data-component-file="AgreementTemplates.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20h-48%20bg-surface%20rounded-xl%22%7D" key={i} className="animate-pulse h-48 bg-surface rounded-xl"></div>
          ))}
        </div>
      </div>
    );
  }

  return null;
}